import CryptoJS from "crypto-js";
import analyticService from "../services/AnalyticService";
import Cookies from "js-cookie";

const toHash = (string) => CryptoJS.SHA256(string).toString(CryptoJS.enc.Hex);

const EventTypes = {
  LOGIN: "login",
  INVITE_A_FRIEND: "invite_a_friend",
  CREATE_RESERVATION: "reserve_class",
  CANCEL_RESERVATION: "cancel_class",
  VIRTUAL_PAGE_VIEW: "VirtualPageview"
};

const ReservationEvents = {
  RESERVATION_CREATED: 'CREATE_RESERVATION_SUCCESS',
  RESERVATION_CANCELED: 'CANCEL_RESERVATION_SUCCESS'
}

const formatDate = (dateString) => {
  const date = new Date(dateString);

  if (!(date instanceof Date) || isNaN(date)) return "";

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padLeft(2, "0");
  const day = date.getDate().toString().padLeft(2, "0");

  return `${day}.${month}.${year}`;
};

const login = async () => {
  const memberDetails = document.body.dataset;

  if (document.referrer.endsWith("members/sign_in") && memberDetails.signIn) {
    const member = JSON.parse(memberDetails.member);

    analyticService.sendEvent(EventTypes.LOGIN, {
      user_id: toHash(member.email),
      membership_start_date: formatDate(member.membership_start),
      membership_end_date: formatDate(member.membership_end),
      membership_plan: member.membership_type,
    });
  }
};

const virtualPageView = async () => {
  let payload = {
    locale: Cookies.get("locale"),
    virtualPageUrl: window.location.pathname
  };
  if (Cookies.get("browsing_club_id")) {
    payload = {
      locale: Cookies.get("locale"),
      browsing_club_id: Cookies.get("browsing_club_id"),
      browsing_club_name: Cookies.get("browsing_club_name"),
      browsing_club_type: Cookies.get("browsing_club_type"),
      browsing_club_city: Cookies.get("browsing_club_city"),
      browsing_club_state: Cookies.get("browsing_club_state"),
      franchisee_group: Cookies.get("browsing_club_franchisee_name"),
      pll_language: Cookies.get("locale"),
      virtualPageUrl: window.location.pathname
    };
  }
  analyticService.sendEvent(EventTypes.VIRTUAL_PAGE_VIEW, payload);
}

const inviteFriend = async () => {
  const memberDetails = document.body.dataset;
  const member = JSON.parse(memberDetails.member);

  analyticService.sendEvent(EventTypes.INVITE_A_FRIEND, {
    user_id: toHash(member.email),
  });
};

const handleReservation = ({ detail: { type, success, occurrence } }) => {
  if (!success) return;

  const member = JSON.parse(document.getElementsByClassName("my-classes")[0].dataset.member);
  const startTime = new Date(occurrence.local_start_time).toLocaleString('en-US', { hour: 'numeric', hour12: true, timeZone: "UTC" });
  const { name: clubName } = JSON.parse(document.getElementById(`club-filter-${occurrence.club_id}`).dataset.location);

  const payload = {
    club_id: occurrence.club_id,
    club_name: clubName,
    class_name: occurrence.activity_name,
    class_instructor: occurrence.instructors.map(instructor => instructor.full_name).join(', '),
    class_time: `${startTime} ${occurrence.time_zone}`,
    user_id: toHash(member.email)
  }

  switch (type) {
    case ReservationEvents.RESERVATION_CREATED:
      analyticService.sendEvent(EventTypes.CREATE_RESERVATION, payload);
      break;
    case ReservationEvents.RESERVATION_CANCELED:
      analyticService.sendEvent(EventTypes.CANCEL_RESERVATION, payload);
      break;
    default:
      break;
  }
}

export default {
  login,
  inviteFriend,
  handleReservation,
  virtualPageView
};
